var map = {
	"./prix_0.png": 636,
	"./prix_1.png": 637,
	"./prix_2.png": 638,
	"./prix_3.png": 639,
	"./prix_4.png": 640,
	"./prix_5.png": 641,
	"./prix_6.png": 642,
	"./prix_special.png": 643
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 635;